module.exports = __webpack_public_path__ + "img/resturant_back3.90e709ed.jpg";